export * from './lib/tcb-fx-transaction.module';
export * from './lib/tcb-transaction-detail/tcb-transaction-detail.component';
